/**
 * 运行时配置（由构建环境决定）
 *
 * API：
 * - 开发（npm run serve）：使用 VUE_APP_API_BASE_URL，直连后端或内网地址
 * - 生产（npm run build）：baseURL 为空，请求为同源 /api/...，由 nginx 反代到真实后端
 */

function normalizeApiBase(url) {
  if (!url) return ''
  return url.endsWith('/') ? url : `${url}/`
}

const isDev = process.env.NODE_ENV === 'development'

/**
 * 是否允许浏览器开发者工具（F12 等）。
 * 未设置 VUE_APP_ENABLE_DEVTOOLS 时：开发环境默认 true，生产默认 false。
 * 生产排查可临时在 .env.production 设 VUE_APP_ENABLE_DEVTOOLS=true 后重新构建。
 */
function readBooleanEnv(name, defaultValue) {
  const v = process.env[name]
  if (v === undefined || v === '') return defaultValue
  return v === 'true' || v === '1'
}

export const DEVTOOLS_ENABLED = readBooleanEnv('VUE_APP_ENABLE_DEVTOOLS', isDev)

/** axios baseURL；生产环境为 undefined，请求走当前站点下的 /api/...，由 nginx 反代 */
export const API_BASE_URL = isDev
  ? normalizeApiBase(process.env.VUE_APP_API_BASE_URL || 'http://localhost:8080/')
  : undefined

/** 去掉末尾 /，供 iframe、window.open 使用 */
function normalizeOrigin(url) {
  if (!url) return ''
  return url.replace(/\/+$/, '')
}

/**
 * 管理后台站点根地址（与 API 独立；iframe / 新窗口打开）
 * 可通过 VUE_APP_ADMIN_ORIGIN 覆盖；默认与线上一致，nginx 仅托管本前端时不影响该外链
 */
export const ADMIN_ORIGIN = normalizeOrigin(
  process.env.VUE_APP_ADMIN_ORIGIN || 'https://zhadmin.aismartenglish.com'
)
